<template>
  <div>
    <el-dialog
      title="点数充值"
      :visible.sync="visible"
      width="800px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      custom-class="recharge-dialog"
    >
      <div class="recharge-container">
        <!-- 充值套餐选择 -->
        <div class="recharge-packages">
          <div
            v-for="item in rechargeList"
            :key="item.id"
            class="package-card"
            :class="{ active: selectedPackageId === item.id }"
            @click="selectPackage(item.id)"
          >
            <div class="level-header">{{ item.name }}</div>
            <div class="level-price">¥{{ item.price }}</div>
            <div class="level-features">
              <div v-for="(feature, fIndex) in item.features" :key="fIndex">
                {{ feature }}
              </div>
            </div>
          </div>
        </div>

        <!-- 支付方式选择 -->
        <div class="payment-methods">
          <div class="payment-title">选择支付方式</div>
          <div class="payment-options">
            <div
              class="payment-option"
              :class="{ active: payMethod === 'alipay' }"
              @click="selectPayMethod('alipay')"
            >
              <img src="../VipMember/alipay-icon.svg" alt="支付宝" />
            </div>
          </div>
        </div>

        <!-- 支付按钮 -->
        <div class="payment-action">
          <el-button 
            type="primary" 
            @click="handlePayment" 
            :loading="paying"
            :disabled="loading || rechargeList.length === 0">
            立即支付 ¥{{ selectedPackagePrice }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 支付弹窗组件 -->
    <order-ali-pay
      :visible.sync="showPayDialog"
      :pay-url="payUrl"
      :order-id="orderId"
      @success="handlePaySuccess"
      @close="handlePayCancel"
    />
  </div>
</template>

<script>
import OrderAliPay from '../VipMember/OrderAliPay.vue'
import EUY from '@/common/scripts/euy.js'

export default {
  name: 'Recharge',
  components: {
    OrderAliPay
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedPackageId: '', // 选中的充值套餐ID
      payMethod: 'alipay',
      paying: false,
      rechargeList: [], // 充值套餐列表
      showPayDialog: false,
      payUrl: '',
      orderId: '',
      payStatusTimer: null,
      loading: false,
    }
  },
  computed: {
    selectedPackagePrice() {
      const pkg = this.rechargeList.find(p => p.id === this.selectedPackageId)
      return pkg ? pkg.price : 0
    }
  },
  watch: {
    visible(val) {
      console.log('Recharge visible', val)
      if (val) {
        this.handleGetRechargeGoods()
        // 默认选中第一个套餐
        if (this.rechargeList.length > 0) {
          this.selectedPackageId = this.rechargeList[0].id
        }
      } else {
        this.rechargeList = []
        this.selectedPackageId = ''
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
    },
    selectPackage(id) {
      this.selectedPackageId = id
    },
    selectPayMethod(method) {
      this.payMethod = method
    },
    handlePayment() {
      if (!this.selectedPackageId) {
        this.$message.warning('请选择充值套餐')
        return
      }
      this.paying = true
      this.handlePostCreateOrder(this.selectedPackageId)
    },
    // 生成订单
    handlePostCreateOrder(goodsId) {
      let URL = process.env.HOST + '/api/storage/order/createOrder'
      
      const formData = new FormData()
      formData.append('goodsId', goodsId)

      let headers = {
        'Authorization': EUY.GetStorage('login_status').tokenId
      }
      
      this.AJAX.post(URL, headers, formData).then((res) => {
        if (res.code === 10000) {
          this.orderId = res.datas.orderId
          // 如果是免费的（status=2），直接处理支付成功
          if (res.datas.status === 2) {
            this.handlePaySuccess()
          } else {
            // 否则创建支付订单
            this.handleCreatePay()
          }
        } else {
          this.$message.error(res.message || '创建订单失败')
        }
      }).catch((err) => {
        console.error('创建订单失败:', err)
        this.$message.error('创建订单失败')
      }).finally(() => {
        this.paying = false
      })
    },
    // 创建支付
    handleCreatePay() {
      let URL = process.env.HOST + '/api/storage/order/createPay'
      
      // 创建FormData对象
      const formData = new FormData()
      formData.append('orderId', this.orderId)
      formData.append('payType', this.payMethod)

      let headers = {
        'Authorization': EUY.GetStorage('login_status').tokenId
      }

      this.AJAX.post(URL, headers, formData).then((res) => {
        if (res.code === 10000) {
          this.payUrl = res.datas.payUrl
          this.orderId = res.datas.orderId
          this.showPayDialog = true
        } else {
          this.$message.error(res.message || '创建支付失败')
        }
      }).catch((err) => {
        console.error('创建支付失败:', err)
        this.$message.error('创建支付失败')
      })
    },
    // 支付成功
    handlePaySuccess() {
      this.$message.success('充值成功')
      this.showPayDialog = false
      this.$emit('update:visible', false)
      this.$emit('success')
      // 刷新页面
      window.location.reload()
    },
    // 取消支付
    handlePayCancel() {
      this.showPayDialog = false
      this.stopCheckPayStatus()
    },
    // 获取充值商品列表
    handleGetRechargeGoods() {
      this.loading = true
      let URL = process.env.HOST + '/api/storage/order/listGoods'
      let token = EUY.GetStorage('login_status').tokenId
      let headers = {
        'Authorization': token
      }
      let params = {
            goodsType: 3
          }

      this.AJAX.get(URL, headers, params).then((res) => {
        if (res.code === 10000) {
          this.rechargeList = res.datas.rows.map(item => ({
            id: item.id,
            name: item.name,
            price: item.price,
            features: this.parseDesc(item.desc)
          }))
          // 默认选中第一个套餐
          if (this.rechargeList.length > 0) {
            this.selectedPackageId = this.rechargeList[0].id
          }
        }
      }).catch((err) => {
        console.error('获取充值套餐失败:', err)
        this.$message.error('获取充值套餐失败')
      }).finally(() => {
        this.loading = false
      })
    },
    // 解析HTML格式的desc
    parseDesc(desc) {
      const parser = new DOMParser()
      const doc = parser.parseFromString(desc, 'text/html')
      const items = doc.querySelectorAll('li')
      return Array.from(items).map(item => item.textContent)
    },
    // 停止支付状态轮询
    stopCheckPayStatus() {
      if (this.payStatusTimer) {
        clearInterval(this.payStatusTimer)
        this.payStatusTimer = null
      }
    }
  },
  beforeDestroy() {
    this.stopCheckPayStatus()
  },
  deactivated() {
    this.stopCheckPayStatus()
  },
}
</script>

<style lang="stylus" scoped>
.recharge-container
  padding: 20px

.recharge-packages
  display: flex
  justify-content: center
  flex-wrap: wrap
  gap: 10px
  margin-bottom: 30px

.package-card
  width: 180px
  height: 150px
  border: 1px solid #EBEEF5
  border-radius: 4px
  padding: 10px
  cursor: pointer
  transition: all 0.3s
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  position: relative
  
  &:hover
    transform: translateY(-2px)
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1)
  
  &.active
    border-color: #409EFF
    background: rgba(64,158,255,0.1)

  .level-header
    font-size 18px
    font-weight bold
    margin-bottom 10px

  .level-price
    font-size 24px
    color #f56c6c
    margin-bottom 15px

  .level-features
    font-size 14px
    color #606266

    > div
      margin-bottom 8px
      line-height 1.4

.payment-methods
  margin-bottom: 30px

.payment-title
  font-size: 16px
  margin-bottom: 15px

.payment-options
  display: flex
  gap: 20px

.payment-option
  border: 1px solid #DCDFE6
  border-radius: 4px
  padding: 10px 20px
  cursor: pointer
  display: flex
  align-items: center
  gap: 10px
  
  &.active
    border-color: #409EFF
    background: rgba(64,158,255,0.1)
  
  img
    height: 24px

.payment-action
  text-align: center
</style>



// WEBPACK FOOTER //
// Recharge.vue?92b216b4